import React, { useState } from "react";
import { CheckCircle2, ShieldCheck, Loader2, ExternalLink } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AltosLoginDialog({ open, onClose }) {
  const { loginAltos } = useStore();
  const [ccode, setCcode] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!ccode.trim() || !password) {
      toast.error("Enter your Altos ID and password");
      return;
    }
    setLoading(true);
    try {
      const res = await api.altosLogin(ccode.trim(), password);
      loginAltos(res.altos_id || ccode.trim(), res.name || "");
      setPassword("");
      toast.success(res.name ? `Welcome, ${res.name}! DP prices unlocked.` : "Altos ID verified — DP prices unlocked for this session");
      onClose();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="altos-login-dialog">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-paper rounded-2xl w-full max-w-md p-7 fade-up">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-11 h-11 rounded-full bg-brandter flex items-center justify-center">
            <ShieldCheck className="text-brand" size={22} />
          </div>
          <h3 className="font-display text-3xl text-ink">Altos ID Login</h3>
        </div>
        <p className="text-sm text-muted2 mb-5">Sign in with your Altos distributor login to unlock DP (distributor) pricing and BV points.</p>
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="altos-id-input"
            value={ccode}
            onChange={(e) => setCcode(e.target.value)}
            placeholder="Altos ID No."
            inputMode="numeric"
            className="w-full h-12 rounded-lg border border-line px-4 text-sm focus:outline-none focus:border-brand"
          />
          <input
            data-testid="altos-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full h-12 rounded-lg border border-line px-4 text-sm focus:outline-none focus:border-brand"
          />
          <button type="submit" disabled={loading} data-testid="altos-id-submit" className="w-full h-12 rounded-lg bg-brand text-white font-semibold flex items-center justify-center gap-2 hover:bg-brand/90 transition-colors disabled:opacity-60">
            {loading ? <><Loader2 className="animate-spin" size={18} /> Verifying with Altos…</> : <><CheckCircle2 size={18} /> Log in & unlock DP prices</>}
          </button>
        </form>
        <a href="https://dss.altosindia.net/login/dsm" target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-brand">
          Forgot password? Open Altos portal <ExternalLink size={12} />
        </a>
        <p className="text-[11px] text-muted2 mt-4 leading-relaxed">
          Your login is verified securely with Altos. We never store your password — you stay logged in for this session only.
        </p>
      </div>
    </div>
  );
}
